"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.$blankLine = void 0;
const factory_1 = __importDefault(require("../factory"));
const line_1 = require("../../../node/cst/line");
/**
 * The parser rule for {@link BlankLine} that represents a blank line. Please see the source code for the detailed syntax, and the [test code](https://github.com/yamachig/Lawtext/blob/main/core/src/parser/cst/rules/$blankLine.spec.ts) for examples.
 */
exports.$blankLine = factory_1.default
    .withName("blankLine")
    .sequence(s => s
    // eslint-disable-next-line no-irregular-whitespace
    .and(r => r.regExp(/^[ 　\t]*\r?\n/), "text")
    .action(({ range, text }) => {
    return { value: new line_1.BlankLine({ range: range(), lineEndText: text }), errors: [] };
}));
exports.default = exports.$blankLine;
//# sourceMappingURL=$blankLine.js.map